import { gql } from '@apollo/client';

export default gql`
  fragment minimalCompanyFragment on Company {
    _id
    subCompanies {
      id
      name
      rut
      activity
      phone
      region
      district
      address
      primary
    }
  }
`;
